import { useMemo } from "react";
import { useAppContext } from "../../contexts/AppContext";

export function useAgentCommissionSettings() {
  const {
    agentCommissionSettings,
    agentCommissionSettingsStatus,
    agentCommissionSettingsError,
    agentCommissionSettingsLoading,
    refreshAgentCommissionSettings,
    saveAgentCommissionSettings,
  } = useAppContext();

  return useMemo(
    () => ({
      fixedHotelCommission:
        Number(agentCommissionSettings?.fixed_hotel_commission) || 0,
      fixedFlightCommission:
        Number(agentCommissionSettings?.fixed_flight_commission) || 0,
      status: agentCommissionSettingsStatus,
      error: agentCommissionSettingsError,
      loading: agentCommissionSettingsLoading,
      refresh: refreshAgentCommissionSettings,
      save: saveAgentCommissionSettings,
    }),
    [
      agentCommissionSettings,
      agentCommissionSettingsStatus,
      agentCommissionSettingsError,
      agentCommissionSettingsLoading,
      refreshAgentCommissionSettings,
      saveAgentCommissionSettings,
    ]
  );
}
